import React, { useMemo } from 'react';
import { IMessage } from '../Messages';
import query from './MessageListQuery.gql';
import {
  MessageListQuery as IQuery,
  MessageListQueryVariables as IVariables,
} from './_QueryTypes/MessageListQuery';
import { ActiveDatabaseContext } from '../../ActiveDatabaseContext/ActiveDatabaseContext';
import {
  TEDSelectionConditionType,
  TEDSelectionOperator,
  TEDInputSelectionCondition,
} from '../../../globalQueryTypes';
import { LoginStateContext } from '../../../Features/Login/Contexts/LoginStateContext/LoginStateContext';
import { getMessageParts } from '../Utils/MessageUtils';
import mergeSort from '../../../Utils/mergeSort';
import { useQuery } from '@apollo/client';

interface IProps {
  children: (messages: IMessage[], loading: boolean) => React.ReactNode;
}

export const getMessageListSelection = (
  sign: string
): TEDInputSelectionCondition[][] => [
  [
    {
      namn: 'SIGNATURE',
      ass: ['Anvandare'],
      typ: TEDSelectionConditionType.Value,
      valueCondition: {
        op: TEDSelectionOperator.equals,
        value: [{ value: sign }],
      },
    },
    {
      namn: 'GILTIGT_TILL',
      ass: ['Meddelande'],
      typ: TEDSelectionConditionType.Value,
      valueCondition: {
        op: TEDSelectionOperator.greater,
        value: [{ value: new Date().toLocaleDateString('sv-SE') }],
      },
    },
  ],
];

const MessageListQuery: React.FC<IProps> = props => {
  const { sign } = React.useContext(LoginStateContext);
  const activeDatabase = React.useContext(ActiveDatabaseContext).activeDatabase;
  const skip = !activeDatabase || !sign;
  const { data, loading } = useQuery<IQuery, IVariables>(query, {
    variables: {
      databaseName: activeDatabase || '',
      selection: getMessageListSelection(sign),
    },
    skip,
  });
  const messages: IMessage[] = useMemo(
    () =>
      mergeSort(
        data?.db?.SYSMeddelandeTill_All?.map(x => {
          const meddelande = x._Associations?.Meddelande;
          return {
            title: meddelande?.RUBRIK ?? '',
            createdDate: new Date(meddelande?.TID.replace(' ', 'T')),
            parts: getMessageParts(meddelande?.TEXT ?? ''),
            id: meddelande?.id ?? '',
            _version: meddelande?._version ?? 1,
            reciever: {
              id: x.id,
              _version: x._version,
              read: Boolean(x.LAST),
            },
          };
        }) ?? [],
        (a, b) => b.createdDate.getTime() - a.createdDate.getTime()
      ),
    [data?.db?.SYSMeddelandeTill_All]
  );
  return <>{props.children(messages, loading || skip)}</>;
};

export default MessageListQuery;
